import moment from "moment";
import { IMonitor, IRecord, ITimelineItem } from "../../inputs/Timeline/Timeline.model";

export const dummyChannelStatuses = ['Recording', 'Paused', 'Stand-by', 'Conflict'] as const;

export const mapRecord = (record: IRecord): ITimelineItem => {
    return {
        id: record.id,
        title: record.title,
        start: moment.utc(record.startedAt).local().toISOString(),
        end: record.endedAt ? moment.utc(record.endedAt).local().toISOString() : null,
        length: moment.duration(moment(record.endedAt).diff(moment(record.startedAt))).asSeconds(),
        playlistLength: moment.duration(moment(record.endedAt).diff(moment(record.startedAt))).asSeconds(),
        channel: record.monitor,
        status: record.status.toString(),
        options: {
            itemType: 'record',
            monitor: record.monitor,
            metadata: record.metadata || {}
        }
    }
}

export const dummyMonitors: IMonitor[] = [
    {
        "id": "mon1",
        "title": "Monitor 1",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon2",
        "title": "Monitor 2",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon3",
        "title": "Monitor 3",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon4",
        "title": "Monitor 4",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon5",
        "title": "Monitor 5",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon6",
        "title": "Monitor 6",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon7",
        "title": "Monitor 7",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    },
    {
        "id": "mon8",
        "title": "Monitor 8",
        "isUrlChangeable": false,
        "recordServiceType": "streamUrl",
        "isRecordable": true,
        "ip": ""
    }
]

export const dummyChannelStatusById = dummyMonitors.reduce<Record<string, (typeof dummyChannelStatuses)[number]>>((acc, monitor, index) => {
    acc[monitor.id] = dummyChannelStatuses[index % dummyChannelStatuses.length];
    return acc;
}, {});

// https://mdrtvsnhls.akamaized.net/hls/live/2016928/mdrtvsn/master.m3u8
// http://zdf-hls-17.akamaized.net/hls/live/2016500/de/high/master.m3u8
// https://srfs.akamaized.net/hls/live/689649/srfsgeo/index.m3u8
// https://mcdn.br.de/br/fs/bfs_nord/hls/de/master.m3u8
